// extracted by mini-css-extract-plugin
export default {"bookInfo":"BookInfo_bookInfo__1RReC","paramValue":"BookInfo_paramValue__AFEUT"};